import { useEditorState } from './states/editor-state';
import { useIdentityState } from './states/identity-state';
import { useLoadingState } from './states/loading-state';

/** 获取多实例id */
export const useIdentity = () => {
    return useIdentityState()((state) => state.id);
};

/** 获取版本 */
export const useVersion = () => {
    return useIdentityState()((state) => state.version);
};

/** 获取加载图层 */
export const useLoadingMap = () => {
    return useLoadingState()((state) => state.loadingMap);
};

/** 获取主题 */
export const useTheme = () => {
    return useEditorState()((state) => state.theme);
};
